import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const deleteCustomer = id =>
  privateAxios({
    method: 'delete',
    baseURL: adminAPI,
    url: `/customer/${id}`,
  });
